import { render, staticRenderFns } from "./OverviewContactBlock.vue?vue&type=template&id=dccf59aa&scoped=true&"
import script from "./OverviewContactBlock.vue?vue&type=script&lang=js&"
export * from "./OverviewContactBlock.vue?vue&type=script&lang=js&"
import style0 from "./OverviewContactBlock.vue?vue&type=style&index=0&id=dccf59aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccf59aa",
  null
  
)

export default component.exports